var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useEffect, useMemo, useState, } from 'react';
import { useConfig } from '../../context/ConfigContext';
import { useEventApi } from '../../hooks/useEvent/useEventApi';
import { useGetMeetingServiceRequestsForEventBySpaceIdLazyQuery, } from '../../../generated/graphql';
import moment from 'moment';
/* @TODO Move these to a types folder? */
var EventDetailContext = createContext({
    /* Event data  */
    loadingEvent: false,
    loadEvent: function () { return Promise.resolve(); },
    eventError: {
        deleting: false,
        fetching: false,
    },
    setEventError: function () { },
    event: null,
    /* Space data for the event */
    spaceData: new Map(),
    canEditSyncedEvents: false,
    timezone: '',
    isRecurringEvent: false,
    onError: function () { },
    showDeleteModal: false,
    setShowDeleteModal: function () { },
    meetingServiceRequestsDataForSpacesLoading: false,
    meetingServiceRequestsDataForSpaces: null,
    removeSpaceInvitee: function () { return Promise.resolve(false); },
    parsedDateTime: null,
    onSuccess: function () { },
});
export var EventDetailContextProvider = function (_a) {
    var _b, _c;
    var children = _a.children, eventId = _a.eventId, timezone = _a.timezone, onClose = _a.onClose, onError = _a.onError, onSuccess = _a.onSuccess;
    var _d = useConfig(), environmentUrls = _d.environmentUrls, userContext = _d.userContext, tenantId = _d.tenantId, accessToken = _d.accessToken;
    var apiUrl = environmentUrls.apiUrl, baseApiUrl = environmentUrls.baseApiUrl;
    var currentOrg = userContext.currentOrg;
    var _e = useEventApi({
        onError: onError,
        apiUrl: apiUrl,
        baseApiUrl: baseApiUrl,
        currentOrg: currentOrg,
        tenantId: tenantId,
        accessToken: accessToken,
    }), fetchEvent = _e.fetchEvent, fetchEditSyncedEvents = _e.fetchEditSyncedEvents, removeSpaceInvitee = _e.removeSpaceInvitee;
    var _f = __read(useState(null), 2), event = _f[0], setEvent = _f[1];
    var _g = __read(useState(null), 2), oldEventId = _g[0], setOldEventId = _g[1];
    /* @TODO Update this to use useReducer: https://github.com/robinpowered/robin-dashboard-apps/pull/4325#discussion_r2449434839 */
    var _h = __read(useState({
        deleting: false,
        fetching: false,
    }), 2), errors = _h[0], setErrors = _h[1];
    var _j = __read(useState(true), 2), isLoading = _j[0], setIsLoading = _j[1];
    var _k = __read(useState(false), 2), showDeleteModal = _k[0], setShowDeleteModal = _k[1];
    var _l = __read(useState(false), 2), canEditSyncedEvents = _l[0], setCanEditSyncedEvents = _l[1];
    var loadEvent = useCallback(function (cancelled) { return __awaiter(void 0, void 0, void 0, function () {
        var event_1, canEdit, error_1, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 6, 7, 8]);
                    return [4 /*yield*/, fetchEvent({ id: eventId, timezone: timezone })];
                case 1:
                    event_1 = _a.sent();
                    if (cancelled)
                        return [2 /*return*/];
                    if (!event_1) {
                        setErrors(function (prev) { return (__assign(__assign({}, prev), { fetching: true })); });
                        setIsLoading(false);
                        onClose();
                        return [2 /*return*/];
                    }
                    setEvent(event_1);
                    setOldEventId(event_1.id);
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    if (cancelled)
                        return [2 /*return*/];
                    return [4 /*yield*/, fetchEditSyncedEvents()];
                case 3:
                    canEdit = _a.sent();
                    setCanEditSyncedEvents(!!canEdit);
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _a.sent();
                    if (cancelled)
                        return [2 /*return*/];
                    return [3 /*break*/, 5];
                case 5: return [3 /*break*/, 8];
                case 6:
                    error_2 = _a.sent();
                    if (cancelled)
                        return [2 /*return*/];
                    onError(new Error("Error fetching event details context: ".concat(error_2)));
                    onClose();
                    /* @TODO add onError prop from event details context */
                    // Sentry.captureException(error);
                    setErrors(function (prev) { return (__assign(__assign({}, prev), { fetching: true })); });
                    return [3 /*break*/, 8];
                case 7:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 8: return [2 /*return*/];
            }
        });
    }); }, [fetchEvent, eventId, timezone, onClose, onError, fetchEditSyncedEvents]);
    useEffect(function () {
        var cancelled = false;
        if (oldEventId === eventId)
            return;
        loadEvent(cancelled);
        return function () {
            cancelled = true;
        };
    }, [loadEvent, oldEventId, eventId]);
    var spaceIds = useMemo(function () {
        if (!(event === null || event === void 0 ? void 0 : event.space_invitees))
            return [];
        return event.space_invitees.map(function (spaceInvitee) { var _a; return ((_a = spaceInvitee.space_id) === null || _a === void 0 ? void 0 : _a.toString()) || ''; });
    }, [event === null || event === void 0 ? void 0 : event.space_invitees]);
    var spaceData = useMemo(function () {
        var e_1, _a;
        var _b, _c, _d;
        if (!event)
            return new Map();
        /* Build map directly in a single iteration */
        var spaceMap = new Map();
        try {
            for (var _e = __values(event.space_invitees), _f = _e.next(); !_f.done; _f = _e.next()) {
                var spaceInvitee = _f.value;
                var spaceId = ((_b = spaceInvitee.space_id) === null || _b === void 0 ? void 0 : _b.toString()) || '';
                var spaceMapHasSpace = spaceMap.has(spaceId);
                var spaceIsDeclined = spaceInvitee.response_status === 'declined';
                var spaceIsManaged = spaceInvitee.space.is_managed;
                // Keep first instance per space_id; include declined spaces only when managed.
                if (!spaceMapHasSpace && (!spaceIsDeclined || spaceIsManaged)) {
                    spaceMap.set(spaceId, __assign(__assign({}, spaceInvitee.space), { isOrganizer: spaceInvitee.is_organizer, inviteeId: spaceInvitee.id, buffer: (_d = (_c = spaceInvitee.invitee_event) === null || _c === void 0 ? void 0 : _c.desired_buffers) !== null && _d !== void 0 ? _d : null, responseStatus: spaceInvitee.response_status, reservationApproval: event.reservation_approval }));
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return spaceMap;
    }, [event]);
    var _m = __read(useGetMeetingServiceRequestsForEventBySpaceIdLazyQuery(), 2), getSpaceForMeetingService = _m[0], _o = _m[1], meetingServiceRequestsDataForSpacesData = _o.data, meetingServiceRequestsDataForSpacesLoading = _o.loading;
    var spaceIdsKey = spaceIds.join(',');
    var eventUid = (_b = event === null || event === void 0 ? void 0 : event.uid) !== null && _b !== void 0 ? _b : null;
    var recurrenceId = (_c = event === null || event === void 0 ? void 0 : event.recurrence_id) !== null && _c !== void 0 ? _c : null;
    useEffect(function () {
        if (!spaceIds.length || !eventUid)
            return;
        getSpaceForMeetingService({
            variables: {
                spaceId: spaceIds,
                eventInstance: {
                    robinEventId: undefined,
                    ical: {
                        uid: eventUid,
                        recurrenceId: recurrenceId,
                    },
                },
            },
            fetchPolicy: 'network-only',
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [getSpaceForMeetingService, spaceIdsKey, eventUid, recurrenceId]);
    var meetingServiceRequestsDataForSpaces = useMemo(function () {
        var e_2, _a;
        if (!meetingServiceRequestsDataForSpacesData)
            return null;
        var map = new Map();
        try {
            for (var _b = __values(meetingServiceRequestsDataForSpacesData.getSpacesByIds), _c = _b.next(); !_c.done; _c = _b.next()) {
                var space = _c.value;
                map.set(space.id, space);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return map;
    }, [meetingServiceRequestsDataForSpacesData]);
    var parsedDateTime = useMemo(function () {
        if (!event)
            return null;
        var date = moment(event.start.date_time).tz(event === null || event === void 0 ? void 0 : event.start.time_zone);
        var startTime = moment(event.start.date_time).tz(event === null || event === void 0 ? void 0 : event.start.time_zone);
        var endTime = moment(event.end.date_time).tz(event === null || event === void 0 ? void 0 : event.end.time_zone);
        return { date: date, startTime: startTime, endTime: endTime };
    }, [event]);
    return (_jsx(EventDetailContext.Provider, { value: {
            loadingEvent: isLoading,
            event: event,
            loadEvent: loadEvent,
            spaceData: spaceData,
            eventError: errors,
            setEventError: setErrors,
            canEditSyncedEvents: canEditSyncedEvents,
            timezone: timezone,
            isRecurringEvent: !!(event === null || event === void 0 ? void 0 : event.series_id),
            onError: onError,
            showDeleteModal: showDeleteModal,
            setShowDeleteModal: setShowDeleteModal,
            meetingServiceRequestsDataForSpaces: meetingServiceRequestsDataForSpaces,
            meetingServiceRequestsDataForSpacesLoading: meetingServiceRequestsDataForSpacesLoading,
            removeSpaceInvitee: removeSpaceInvitee,
            parsedDateTime: parsedDateTime,
            onSuccess: onSuccess,
        }, children: children }));
};
export var useEventDetailContext = function () {
    return useContext(EventDetailContext);
};
